function toFixed(nbr: number) {
  return typeof nbr !== "undefined"
    ? Math.round(nbr) === nbr
      ? nbr
      : nbr.toFixed(2)
    : "";
}

export { toFixed };
